// Nuxt's built-in useAsyncData caching only reuses `nuxtApp.payload.data`
// while the client is hydrating right after SSR — it does NOT cover two
// separate server-side useAsyncData calls sharing a key within the same SSR
// pass (e.g. plugins/initial-data.js prefetching 'globalSettings' /
// 'cms-page-*' concurrently, then layouts/default.vue and useCmsPage.js
// calling useAsyncData with the same key again). Without this, the second
// call just re-fetches from scratch, doubling backend requests and
// reintroducing the sequential wait we prefetched to avoid.
//
// This mirrors Nuxt's own default getCachedData exactly, adding only the
// `process.server` branch — client-side caching behavior is unchanged.
export function getCachedDataWithServerPrefetch(key, nuxtApp, ctx) {
  if (process.server) return nuxtApp.payload.data[key];

  if (nuxtApp.isHydrating) return nuxtApp.payload.data[key];
  if (ctx.cause !== 'refresh:manual' && ctx.cause !== 'refresh:hook') {
    return nuxtApp.static.data[key];
  }
}
